<div class="main">
    <div class="container-fluid mt-3 mb-4 pb-4">
        <div class="row">
            <div class="col-12">
                <app-chat></app-chat>
            </div>
        </div>
    </div>
</div>